var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCircledSellCard({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 61,
    height: 61,
    viewBox: "0 0 61 61",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 30.6665,
    cy: 30.5,
    r: 30,
    fill: "#EEF2F3"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23 18.75L18.625 24H21.25V28.375H24.75V24H27.375L23 18.75ZM35.25 18.75V23.125H32.625L37 28.375L41.375 23.125H38.75V18.75H35.25ZM39.6303 29.9557C39.3415 29.9623 39.0718 30.0879 38.7038 30.4805L38.345 30.8616L37.9724 30.4941C37.5684 30.096 37.2497 29.986 36.9265 30.0003C36.6034 30.0145 36.2235 30.1843 35.7986 30.5282L35.4585 30.8033L35.1355 30.5094C34.6488 30.0691 34.234 29.9386 33.8367 29.9591C33.5475 29.9741 33.2474 30.0831 32.948 30.2736L35.1885 34.3033C36.0336 34.8202 37.7606 35.0148 38.9482 34.4163L41.1135 30.4052C40.7028 30.2377 40.3337 30.0661 40.0147 30.0003C39.8991 29.9764 39.7919 29.9588 39.6882 29.9557C39.6688 29.9552 39.6495 29.9552 39.6302 29.9557H39.6303ZM20.8125 30.125C18.625 30.125 18.625 30.125 18.625 32.3125V41.0655C18.625 43.25 18.625 43.25 20.8125 43.25H25.1875C27.375 43.25 27.375 43.25 27.375 41.0625V32.3125C27.375 30.125 27.375 30.125 25.1875 30.125H20.8125ZM34.71 35.2161V35.2162C33.7237 35.913 32.9317 37.1148 32.625 38.875C32.3278 40.581 32.796 41.7332 33.6247 42.5184C34.4535 43.3038 35.6975 43.7072 36.9607 43.6908C38.224 43.6744 39.4837 43.2364 40.3308 42.4365C41.1779 41.6366 41.657 40.4992 41.3853 38.8716C41.1044 37.1895 40.379 36.0198 39.4608 35.3118C37.9032 36.1352 35.9557 35.9602 34.71 35.2161Z",
    fill: "#00525D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCircledSellCard);
export default __webpack_public_path__ + "static/media/circled-sell-card.3843fe36f2f61cb4a79b98f6bff151e3.svg";
export { ForwardRef as ReactComponent };